/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    function isElementInView(el) {
        if (!el.offsetParent) {
            return false;
        }

        var rect = el.getBoundingClientRect(),
            elemTop = rect.top,
            elemBottom = rect.bottom;

        return elemTop < window.innerHeight && elemBottom >= 0;
    }

    function bindScrollEvent(el) {
        let tracked = false;

        function track() {
            if (tracked) {
                return;
            }
            tracked = true;
        }

        window.addEventListener('scroll', function () {
            if (tracked || !el.offsetParent) {
                return;
            }

            if (isElementInView(el)) {
                track();
            }
        });

        window.setTimeout(function () {
            if (isElementInView(el)) {
                track();
            }
        }, 5000);
    }

    function watchPagination() {
        Mojito.utils.waitForElement('.pagination .page.current', bindScrollEvent);
    }

    function handlePaginationButtons() {
        Mojito.utils.observeSelector('.pagination > .prev, .pagination > .next', function (element) {
            var holder = element.closest('.pagination').querySelector('.btn-holder');
            if (!holder) {
                holder = document.createElement('div');
                holder.className = 'btn-holder';
                element.closest('.pagination').insertAdjacentElement('beforeend', holder);
            }

            var linkContents = element.querySelector('a');

            if (element.classList.contains('prev')) {
                holder.insertAdjacentElement('afterbegin', element);
                linkContents.innerHTML = `
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98">
                        <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path>
                    </svg>
                    &nbsp; <span class="icon__fallback-text">Previous</span>
                `;
            } else {
                holder.insertAdjacentElement('beforeend', element);
                linkContents.innerHTML = `
                    <span class="icon__fallback-text">Next</span>
                    &nbsp;
                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98">
                        <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path>
                    </svg>
                `;
            }
        });
    }

    function initialize() {
        if (!/^\/collections\//.test(location.pathname)) {
            return;
        }

        Mojito.utils.domReady(function () {
            watchPagination();
            handlePaginationButtons();
        });
    }

    initialize();
})();
